import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { g as upSmall, d as downSmall } from './index2.js';
import { d as defineCustomElement$1 } from './pds-icon2.js';

const pdsTableHeadCellCss = ":host{--border-head-cell-default:var(--pine-border-width-thin) solid var(--pine-color-grey-100);--box-shadow-default:3px 3px 6px -2px rgba(0, 0, 0, 0.1);-webkit-border-after:var(--border-head-cell-default);border-block-end:var(--border-head-cell-default);color:var(--pine-color-text);display:table-cell;font-family:var(--pine-font-family-body);font-size:var(--pine-font-size);font-weight:var(--pine-font-weight-regular);line-height:var(--pine-line-height-body);padding:12px;text-align:start;vertical-align:inherit}:host(.is-compact){padding-block:var(--pine-dimension-2xs)}:host(.is-fixed){background:var(--pine-color-background-container);left:var(--pine-dimension-none);position:-webkit-sticky;position:sticky;z-index:1}:host(.has-scrolled.is-fixed){-webkit-box-shadow:var(--box-shadow-default);box-shadow:var(--box-shadow-default)}:host(.is-sortable){cursor:pointer}:host(.is-sortable) pds-icon{-webkit-margin-start:var(--pine-dimension-2xs);margin-inline-start:var(--pine-dimension-2xs);-webkit-padding-before:2px;padding-block-start:2px;position:absolute}:host(.is-sortable:hover),:host(.is-active){color:var(--pine-color-text-active)}";
const PdsTableHeadCellStyle0 = pdsTableHeadCellCss;

const PdsTableHeadCell = /*@__PURE__*/ proxyCustomElement(class PdsTableHeadCell extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.pdsTableSort = createEvent(this, "pdsTableSort", 7);
        this.handleScroll = () => {
            if (this.tableRef.scrollLeft > 0) {
                this.tableScrolling = true;
            }
            else {
                this.tableScrolling = false;
            }
        };
        this.toggleSort = () => {
            if (this.sortable) {
                const column = this.hostElement.innerText.trim();
                this.sortingDirection = this.sortingDirection === 'asc' ? 'desc' : 'asc';
                this.tableRef.querySelectorAll('pds-table-head-cell').forEach((headCell) => {
                    headCell.classList.remove('is-active');
                });
                this.hostElement.classList.toggle('is-active');
                this.pdsTableSort.emit({ column, direction: this.sortingDirection });
            }
        };
        this.sortable = undefined;
        this.sortingDirection = 'asc';
        this.tableScrolling = false;
        this.isSelected = false;
    }
    componentWillRender() {
        this.tableRef = this.hostElement.closest('pds-table');
    }
    componentDidLoad() {
        if (this.tableRef && this.tableRef.responsive && this.tableRef.fixedColumn) {
            this.tableRef.addEventListener('scroll', this.handleScroll);
        }
    }
    classNames() {
        const classNames = [];
        if (this.tableRef && this.tableRef.compact) {
            classNames.push('is-compact');
        }
        if (this.sortable) {
            classNames.push('is-sortable');
        }
        if (this.sortable && this.sortingDirection !== null) {
            classNames.push('sort-' + this.sortingDirection);
        }
        if (this.tableRef && this.tableRef.fixedColumn && this.tableScrolling) {
            classNames.push('has-scrolled');
        }
        return classNames.join('  ');
    }
    render() {
        return (h(Host, { key: '0eae693d1a14a1c7a21a9841a9bb6fbce9c3fe39', class: this.classNames(), role: "columnheader", onClick: this.toggleSort, style: this.tableRef &&
                this.tableRef.fixedColumn &&
                this.tableRef.selectable
                ? { '--fixed-cell-position': '40px' }
                : {} }, h("slot", { key: 'ce895362068b7912c3bb2ef46de0c2194417ebb4' }), this.sortable && (h("pds-icon", { key: '1fb79e6e54adecef28106f6b28537c6a48cd7182', icon: this.sortingDirection === 'asc' ? upSmall : downSmall }))));
    }
    get hostElement() { return this; }
    static get style() { return PdsTableHeadCellStyle0; }
}, [1, "pds-table-head-cell", {
        "sortable": [4],
        "sortingDirection": [32],
        "tableScrolling": [32],
        "isSelected": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-table-head-cell", "pds-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-table-head-cell":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsTableHeadCell);
            }
            break;
        case "pds-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { PdsTableHeadCell as P, defineCustomElement as d };

//# sourceMappingURL=pds-table-head-cell2.js.map